import './bluefiretotal5/style';
import FormStructure from './bluefiretotal5/form_structure';

export default FormStructure;